import { dictDataApi } from '@/api/dict/index'
// initial state
const state = {
  dictData: {},
  locationInfo: {
    areaName: '厦门市',
    parentRegionId: 'p13',
    regionId: 'p13r1'
  },
  loginBackFullPath: ''
}

// getters
const getters = {
  dictData: state => state.dictData,
  loginBackFullPath: state => state.loginBackFullPath
}

// actions
const actions = {
  // 获取全局数据字典
  dictDataAction ({ commit }) {
    return new Promise((resolve, reject) => {
      dictDataApi().then(response => {
        if (response.status === '2000') {
          let regionNameMap = {}
          response.data.region.forEach(region => {
            regionNameMap[region.name] = region
          })
          let dictData = response.data
          dictData.regionNameMap = regionNameMap
          commit('setDictData', dictData)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 定位信息
  locationInfoAction ({ commit }) {
    var locationInfo = {}
    return new Promise((resolve, reject) => {
      locationInfo.areaName = '厦门市'
      locationInfo.parentRegionId = 'p13'
      locationInfo.regionId = 'p13r1'
      AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          timeout: 10000
        })
        geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete' && result.info === 'SUCCESS') {
            var city = result.addressComponent ? result.addressComponent.city : ''
            if (city && state.dictData.regionNameMap && state.dictData.regionNameMap[city]) {
              locationInfo.areaName = city
              const region = state.dictData.regionNameMap[city]
              locationInfo.regionId = region.value
              locationInfo.parentRegionId = region.parent
            }
            locationInfo.longitude = result.position.lng
            locationInfo.latitude = result.position.lat
            commit('setLocationInfo', locationInfo)
          }
        })
      })
      commit('setLocationInfo', locationInfo)
      resolve()
    })
  }
}

// mutations
const mutations = {
  setDictData (state, dictData) {
    state.dictData = dictData
    window.localStorage.setItem('dictData', JSON.stringify(dictData))
  },
  setLocationInfo (state, locationInfo) {
    state.locationInfo = locationInfo
    window.localStorage.setItem('locationInfo', JSON.stringify(locationInfo))
  },
  setLoginBackFullPath (state, loginBackFullPath) {
    state.loginBackFullPath = loginBackFullPath
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dict/index.js